import { render, staticRenderFns } from "./leave-request.vue?vue&type=template&id=3cc593ca"
import script from "./leave-request.vue?vue&type=script&lang=js"
export * from "./leave-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports